import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { BackButton, TableData, TxnLogView } from 'components';
import { getAlertMonitorTxnsService, getIntermittenceTxns } from 'services/admin/alertsService';
import { errorAlert } from 'helpers/alerts';
import moment from 'moment';
import { Grid } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { BugReport } from '@mui/icons-material';
import { Loader } from 'rsuite';
import { getLogsTxnService } from 'services/panelService';
import DialogModal from 'components/modal/DialogModal';

const IntermittenceTxnsScreen = () => {
  const navigate = useNavigate();
  const { currentIntermittence } = useSelector(store => store.alert);
  const [txns, setTxns] = useState([])
  const [loading, setLoading] = useState(false)

  const [dialog, setDialog] = useState({ open: false, title: '', body: '' });
  const [loadingLog, setLoadingLog] = useState(false);

  // El identificador de la transaccion no se llama igual en todas las respuestas: el
  // panel lo trae como `id` y los reportes como `_id`.
  const txnId = (data) => data?._id || data?.id;

  useEffect(() => {
    setLoading(true);
    getIntermittenceTxns(currentIntermittence.id).then((response) => {
      setTxns(response)
    }).catch(error => errorAlert(error))
      .finally(() => setLoading(false));
    // eslint-disable-next-line
  }, []);

  return (
    <>
      <Grid
        container
        direction="row"
        justifyContent="space-between"
        alignItems="center"
      >
        <div>
          <BackButton
            name={"Alertas"}
            click={() => navigate(-1)}
          />
        </div>
        <div className="container-title">
          <div className="title">Intermitencia - {currentIntermittence.providerCredential?.name_connector}</div>
          <div className="subtitle">{moment(currentIntermittence.createdAt).format("DD/MM/YYYY HH:mm:ss")}</div>
          {currentIntermittence.end && <div className="subtitle">{moment(currentIntermittence.end).format("DD/MM/YYYY HH:mm:ss")}</div>}
        </div>
        <div style={{ width: "170px" }}></div>
      </Grid>
      <TableData
        dataRows={txns}
        loading={loading}
        dataTitle={[
          "Fecha Hora",
          "Bolsa",
          "Operadora",
          "Producto",
          "Monto",
          "Número",
          "Código",
          "Estado",
          "Tiempo",
        ]}
        formatter={({
          createdAt,
          hosterBagId,
          operator,
          amount,
          phoneNumber,
          productId,
          ProviderResponseCode,
          ProviderResponseMessage,
          time
        }) => [
            moment(createdAt).format('DD/MM/YYYY HH:mm:ss '),
            hosterBagId?.hashtag,
            operator,
            productId,
            `$ ${Number(amount || 0).toFixed(2)}`,
            phoneNumber,
            ProviderResponseCode,
            ProviderResponseMessage,
            `${time} ms`,
          ]}
        actions={[
          {
            label: "Logs",
            icon: (data) => loadingLog === txnId(data) ? <Loader size="xs" /> : <BugReport />,
            validate: (data) => Boolean(txnId(data)),
            onClick: async (data) => {
              const id = txnId(data);
              setLoadingLog(id);
              try {
                const result = await getLogsTxnService(id);
                setDialog({
                  open: true,
                  maxWidth: 'lg',
                  title: `Log Transacción ${id}`,
                  textAlign: 'left',
                  body: <TxnLogView data={result} />,
                  onClose: () => setDialog({ open: false })
                });
              } catch (error) {
                errorAlert(error);
              } finally {
                setLoadingLog(false);
              }
            },
          },
        ]}
      />
      <DialogModal
        open={dialog.open}
        title={dialog.title}
        body={dialog.body}
        maxWidth={dialog.maxWidth}
        textAlign={dialog.textAlign}
        onClose={dialog.onClose}
      />
    </>

  )
}

export default IntermittenceTxnsScreen